import { createFileRoute } from '@tanstack/react-router'
import { AgentDashboard } from '../../../../components/AgentDashboard'

export const Route = createFileRoute('/desa/$slug/dashboard/agen')({
  component: () => {
    const { desaId } = Route.useRouteContext() as any
    if (!desaId) return null
    return <AgentDashboard desaId={desaId} />
  },
})
